import React, { useEffect ,useState} from "react";
import {Empty,Button, Pagination,Badge } from "antd";
import useStatsStore from "../../../store/stats.store";
import TableDashBoard from "../../TableDashBoard";

import "../teamAssignment.scss";
import Filter from "../../filter";
import useSettingstore from "../../../store/settings.store";

export default function TeamAssignmentResumeSharing({currentView,cb}) {

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { getSettingByKey, addOrUpdateSetting } = useSettingstore();
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };  
  const {teamsDashConsolidatedStatsResumesShared,getTeamsDashBoardConsolidatedStatsResumesShared,teamsDashConsolidatedStatsResumesSharedCount} = useStatsStore();
  const {getTeamsDashBoardConsolidatedStatsPositiveFeedbacks,teamsDashConsolidatedStatsPositiveFeedbackCount} = useStatsStore();
  const {getTeamsDashBoardConsolidatedStatsInterviewScheduling,teamsDashConsolidatedStatsInterviewSchedulingCount} = useStatsStore();
  const {getTeamsDashBoardConsolidatedStatsNegativeFeedback,teamsDashConsolidatedStatsNegativeFeedbackCount} = useStatsStore();
  const {getTeamsDashBoardConsolidatedStatsSelectionAndOffers,teamsDashConsolidatedStatsSelectionAndOffersCount} = useStatsStore();
  
  useEffect(() => {
    //getAllJds()
  }, []);


  const resumeSharingList = [
    "Sr. No.",
    "Client",
    "TA",
    "Job Title",
    "SPOC",
    "Assigned To",
    "Resumes Shared",
    "Resumes FB Pending",
    "Duplicates",
    "EndClient FB Pending",
  ];


  const resumeDetailData = teamsDashConsolidatedStatsResumesShared?.resumesharing?.map((resume, idx) => {
    return {
      id: idx + 1 + (pageSize *(currentPage-1)),  
      client_name: resume?.client,
      ta_name: resume?.ta,
      title: '['+resume?.qhcompanyjid+'] '+resume?.title,
      SPOC: resume?.spoc,
      assigned_to: resume?.assignedto,
      shared: resume?.noofresumesshared===0?"-":resume?.noofresumesshared,
      fb_pending: resume?.nooffeedbackpending===0?"-":resume?.nooffeedbackpending,
      duplicates: resume?.noofduplicate===0?"-":resume?.noofduplicate,
      efb_pending: resume?.noofendclientfeedbackpending===0?"-":resume?.noofendclientfeedbackpending,
    };
  });


  return (
    <div className="teamAssignmentPages-wrapper">
      <Filter
        filtername = {"getTeamsDashBoardFilter"}
        initDuration={"24"}
        initPrio={"All"}
        initJDStatus={"Active"}
        initClient={"All"}               
        enableDuration
        enablePriority
        enableJdStatus
        enableCustomers   
        enableTAs   
        handleFilter={cb}
        pageNo={currentPage}
        pageSize={pageSize}
        pageHandler = {setCurrentPage}  
      />      
      <div></div>

      {teamsDashConsolidatedStatsResumesShared ? (
        <>
           {currentView==="Resume Sharing"?
             <>
              <TableDashBoard
                isClickable={true}
                isJDPage={true}
                titleList={resumeSharingList}
                data={resumeDetailData}
              />             
             </>:<></>
           }                                       
        </>
        
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}

       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={teamsDashConsolidatedStatsResumesSharedCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
        />            
    </div>
  );
}
